export const vehicleExistsAtDealership = `
Hello,

I tried to add the VIN $VIN to my dealership and received a message that the VIN already exists at another dealership.

Could you please help with this?
`;
export const vehicleOwnedByCustomer = `
Hello,

I tried to add the VIN $VIN to my dealership and received a message that the VIN already belongs to a customer.

Could you please help with this?
`;